import { createContext } from 'react'

// TODO: configure for other upsells
export const UpsellsContext = createContext<{
    isEditingSpaInProgress: boolean
    setSpaEditing: (isSpaEditing: boolean) => void
}>({
    isEditingSpaInProgress: false,
    setSpaEditing: () => null,
})
